import { useEffect } from "react";
import { PagesResourceAutoLogUiDisplay } from "./Display";

export const PagesResourceAutoLogUi = () => {
  useEffect(() => {
    document.title = "ResourceAutoLog";
  }, []);
  return <PagesResourceAutoLogUiDisplay />;
};
